var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "4.8,19.3 4.3,16 2.7,12.6 12,9.9 21,12.5 19.6,16 19.2,19.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.3,11.5V6.7c0-0.7,0.5-1.2,1.2-1.2h9.1c0.7,0,1.2,0.5,1.2,1.2v4.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 12,
    y1: 5.5,
    x2: 12,
    y2: 2.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.2,
    y1: 14.1,
    x2: 7.2,
    y2: 15.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 16.7,
    y1: 14.1,
    x2: 16.7,
    y2: 15.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2,20c0.3,0.3,1.4,1.2,3.2,1.3c1.6,0.1,2.8-0.6,3.4-1c0.2-0.2,0.5-0.2,0.7,0c0.5,0.4,1.6,1,3,1 c1.3,0,2.3-0.6,2.8-1c0.2-0.2,0.5-0.2,0.7,0c0.6,0.4,1.7,1,3.2,0.9c1.6-0.1,2.6-0.9,3-1.2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.05024584cdd2959348c889023fb37519.svg";
export { ForwardRef as ReactComponent };